// extracted by mini-css-extract-plugin
export default {"varFontSize100":"0.75rem","pill":"pill--mp-b_s8_"};